import React, { useContext } from 'react'
import { ItemType, LifeCycle, Priority, Progress, TodoContext } from './Project';
import Todo from './Todo';

export default function TodoLab() {
  const {tasks, setTasks} = useContext(TodoContext);
  const lines = tasks.filter(task => task.lifeCycle === LifeCycle.Lab);
 
  const add = (e) => {
    setTasks([{
        id: crypto.randomUUID(),
        text: ``,
        priority: Priority.None,
        lifeCycle: LifeCycle.Lab,
        progress: Progress.InProgress,
        itemType: ItemType.Task
    }, ...tasks]);
  }

  return ( 
    <Todo title='Lab' lines={lines} titleStyle='titleLab' anAdd={add}/>
  );
}
